import React, { useEffect, useState } from "react";
import { ErrorMessage } from "../../components/ErrorMessage";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { ListCommanWay } from "API/commonApi";
import { Link } from "react-router-dom";
import { AfDataType } from "utils/TableColumnData";
import moment from "moment";
import { AxiosResponse } from "axios";
import { Popover, Transition } from "@headlessui/react";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { AwbLabel } from "components/PrintLabels/AwbLabel";
import { Table, TableHeader, TableBody, TableColumn, TableRow, TableCell } from "@heroui/table";

export type AfTableProps = Partial<{
  errors: any[];
  columnData: any[];
  apiUrl: string;
  isDataAdded: any;
  query: any;
  responseData: string;
  handleEdit: Function;
  handleView: Function;
  handleCustom: Function;
  customBtnText?: string;
  fetchedData?: any;
  setFetchedData?: any;
  customRenderFunction?: Function;
  currentPage: number;
  setCurrentPage: any;
}>;

const PickupDatatable: React.FC<AfTableProps> = ({
  errors = [],
  columnData = [],
  apiUrl = "/",
  isDataAdded = false,
  handleEdit = (id) => {},
  handleView = (id) => {},
  handleCustom = (id) => {},
  currentPage = 1,
  setCurrentPage,
  customBtnText = "",
  query = {},
  responseData = "",
  fetchedData = null,
  setFetchedData = null,
  customRenderFunction = undefined,
}) => {
  const [tableData, setTableData] = useState<any>([]);

  const [perPage, setPerPageCount] = useState<number>(100);
  const [pageCount, setPageCount] = useState<number>(1);
  const [itemCount, setItemCount] = useState<number>(1);
  const [foundAwbs, setFoundAwbs] = useState<any>({});
  const [sortStat, setSortStat] = useState<any>({});

  const [isLabelOpen, setIsLabelOpen] = useState<any>({});

  //const [includes, setIncludes] = useState<any>([]);
  let incAry = [];
  columnData.forEach((c) => {
    if (c.db_col) {
      incAry.push("_" + c.key);
    }
  });
  //setIncludes(incAry);

  const { error, isFetching, isError, isFetched, isLoading, refetch } = useQuery(
    [apiUrl.replaceAll("/", "__")],
    () =>
      ListCommanWay(apiUrl, Object.keys(query).length > 0 ? query : {}, {
        include: incAry,
        order: [["id", "desc"]],
        paginate: perPage,
        ...(currentPage !== 1 ? { page: currentPage } : null),
      }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);

          if (setFetchedData) {
            setFetchedData(data[responseData]);
          }
          if (responseData) {
            setTableData(data[responseData]);
            setCurrentPage(data[responseData]?.currentPage);
            setPerPageCount(data[responseData]?.perPage);
            setPageCount(data[responseData]?.pageCount);
            setItemCount(data[responseData]?.itemCount);
            return;
          }

          let pickupCodes = [];
          data.data.data.forEach((p) => {
            pickupCodes.push(p.pickup_code);
          });
          mutate(pickupCodes);

          setTableData(data.data.data);
          setCurrentPage(data.data.paginator?.currentPage);
          setPerPageCount(data.data.paginator?.perPage);
          setPageCount(data.data.paginator?.pageCount);
          setItemCount(data.data.paginator?.itemCount);
        } else {
          console.log("asadssad");

          setTableData([]);
          setCurrentPage(1);
          setPerPageCount(100);
          setPageCount(1);
          setItemCount(1);
        }
      },
      onError: (data) => {
        setTableData([]);
        setCurrentPage(1);
        setPerPageCount(100);
        setPageCount(1);
        setItemCount(1);
      },
    }
  );

  const { mutate: mutate }: any = useMutation((codes) => ListCommanWay("/admin/pickup/list", { findAwbInPickup: 1, codes }, {}), {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        console.log("findAwbInPickup", data.data);
        let awbs: any = {};
        data.data.forEach((a) => {
          if (!awbs[a.pickup_code]) {
            awbs[a.pickup_code] = [];
          }
          awbs[a.pickup_code].push(a.awb_no);
        });
        setFoundAwbs(awbs);
      }
    },
    onError: (data: any) => {},
  });

  const renderSwitch = (param) => {
    switch (param) {
      case "foo":
        return "bar";
      default:
        return "foo";
    }
  };

  useEffect(() => {
    //console.log("fetchedData", fetchedData);
    refetch();
  }, [fetchedData]);
  //console.log("========> fetchedData", fetchedData, "currentPage", currentPage);

  useEffect(() => {
    refetch();
  }, [isDataAdded, currentPage]);

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    let sortedData = data.sort((a, b) => {
      let valueA = key.split(".").reduce((obj, k) => obj?.[k], a) || "";
      let valueB = key.split(".").reduce((obj, k) => obj?.[k], b) || "";

      if (key === "pickup_date_time") {
        const dateA = moment(valueA, "DD-MM-YYYY HH:mm:ss");
        const dateB = moment(valueB, "DD-MM-YYYY HH:mm:ss");

        if (!dateA.isValid() || !dateB.isValid()) return 0;

        return order === "asc" ? dateA.valueOf() - dateB.valueOf() : dateB.valueOf() - dateA.valueOf();
      }

      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const setAWbData = (pickupData) => {
    let awbData = {
      id: pickupData.id || "",
      isPickup: true,
      awb_no: pickupData.pickup_code || "",
      destination: pickupData.consignee_city || "",
      consignee: pickupData.consignee_cgnee || "",
      address: pickupData.consignee_address || "",
      pincode: pickupData.consignee_pincode || "",
      commercialValue: "",
      is10_30: pickupData.ten_30 || false,
      holiday: pickupData.holiday || false,
      dox_or_non_dox: pickupData.type == "DOX" ? true : false,
      innerItemsNos: 1,
      _assign_to_booking: {
        shipper_city: pickupData.shipper_city || "",
        date: pickupData.pickup_date_time || pickupData.date,
      },
    };
    setIsLabelOpen(awbData);
  };

  return (
    <div className="p- overflow-x-auto">
      {isLabelOpen.id && (
        <AwbLabel
          isLabelOpen={isLabelOpen.id}
          setIsLabelOpen={(el) => {
            setIsLabelOpen(el ? { id: el } : {});
          }}
          awbData={isLabelOpen}
          setAwbData={() => {}}
        />
      )}

      <div className="overflow-visible">
        <Table
          isHeaderSticky
          removeWrapper
          className="w-full text-sm text-left text-gray-500 font-RobotoCondensed"
          aria-label="collection table"
          classNames={{
            td: "group-data-[odd=true]/tr:before:bg-blue-100 p-1", // light blue
          }}
        >
          <TableHeader className="text-gray-700 uppercase bg-gray-50 sticky top-0">
            {columnData.map((c) => {
              return (
                c.view && (
                  <TableColumn key={c.label + "hdr-tbl"}>
                    {c.label}
                    {c.sort && GET_SORT_ICON(c.key, "")}
                  </TableColumn>
                )
              );
            })}
          </TableHeader>

          <TableBody>
            {!tableData.length && (
              <TableRow>
                <TableCell colSpan={18} className="text-center">
                  No Data Found
                </TableCell>
              </TableRow>
            )}

            {tableData.map((rd, j) => {
              let rowColor = "";
              if (rd.status == 1) {
                rowColor = "bg-green-700";
              } else if (rd.status == 2) {
                rowColor = "bg-red-700";
              } else if (rd.status == 4) {
                rowColor = "bg-yellow-400";
              }

              return (
                <TableRow key={"tbl-tr-" + j} className={`border-b ${rowColor}/5 text-black-900`}>
                  {columnData.map((cd, i) => {
                    let bgColor = "";
                    if (cd.bg_color_key) {
                      let index = columnData.findIndex((item) => item.key == cd.bg_color_key);
                      let bgColorAry = columnData[index].bg_color;
                      bgColor = bgColorAry[rd[cd.bg_color_key]];
                    }

                    return (
                      <TableCell className={`${i != 0 ? "border-x" : ""} border-gray-300 text-black-900`} key={"tbl-td-" + i}>
                        {cd.type == AfDataType.CUSTOM ? (
                          customRenderFunction !== undefined ? (
                            customRenderFunction(rd)
                          ) : (
                            <button className="text-dark1" onClick={() => handleCustom(rd)}>
                              {customBtnText}
                            </button>
                          )
                        ) : cd.type == AfDataType.EDIT ? (
                          <div className="text-center">
                            <button className="text-dark1" onClick={() => handleEdit(rd)}>
                              Edit
                            </button>
                            <button className="text-dark1 font-semibold font-inter underline" onClick={() => setAWbData(rd)}>
                              Label
                            </button>
                          </div>
                        ) : cd.type == AfDataType.VIEW ? (
                          <button className="text-dark1" onClick={() => handleView(rd)}>
                            View
                          </button>
                        ) : cd.type == AfDataType.DB && cd.key == "updatedBy" ? (
                          <>
                            {rd["_" + cd.key] ? (
                              rd["_" + cd.key][cd.db_col] == "EXA" ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  id="svg16910"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 316 1024 256"
                                  xmlSpace="preserve"
                                >
                                  <defs>
                                    <style type="text/css">{".st2 { fill: url(#SVGID_1_); }"}</style>
                                    <linearGradient
                                      id="SVGID_1_"
                                      gradientUnits="userSpaceOnUse"
                                      x1="14.7645"
                                      y1="447.1195"
                                      x2="1009.2247"
                                      y2="447.1195"
                                    >
                                      <stop offset="0" style={{ stopColor: "#034DA2" }} />
                                      <stop offset="0.5" style={{ stopColor: "#B646A2" }} />
                                      <stop offset="1" style={{ stopColor: "#FF6464" }} />
                                    </linearGradient>
                                  </defs>
                                  <path
                                    className="st2"
                                    d="M63.8,514.4h102.9v42.5H63.8H14.8V335.9h49.1h102.9v42.5l-102.9,0v47.4h85.8v42.5H63.8V514.4z M351.2,393.3h-48.4l-23.6,38.2l-4.8,7.8l-4.8-7.8L246,393.3h-48.4l47.4,76.8l-53.8,84.5h45.1l30.9-48.5l7.1-11.2l7.1,11.2l30.9,48.5h45.1l-53.8-84.5L351.2,393.3z M540.2,474.5c0,0.3,0,0.5,0,0.8h0v81.6h-42.1v-9.7c-12.3,7.1-26.6,11.2-41.8,11.2c-46.2,0-83.9-37.6-83.9-83.9c0-46.2,37.6-83.9,83.9-83.9C502.5,390.6,540.2,428.2,540.2,474.5z M498.1,474.5c0-23-18.7-41.8-41.8-41.8s-41.8,18.7-41.8,41.8c0,23,18.7,41.8,41.8,41.8C479.3,516.3,498.1,497.5,498.1,474.5z M810,336.2l-27.7,49.9l-95,171.1h58.9l65.6-118.1l65.6,118.1h55.4l-93.3-168L810,336.2z M960.2,335.9v221h49.1v-221H960.2z"
                                  />
                                </svg>
                              ) : rd["_" + cd.key][cd.db_col] == "Customer" ? "Customer" : "Staff"
                            ) : (
                              "-"
                            )}
                          </>
                        ) : cd.type == AfDataType.DB ? (
                          <>{rd["_" + cd.key] ? rd["_" + cd.key][cd.db_col] : "-"}</>
                        ) : cd.type == AfDataType.SELECT ? (
                          <>
                            {cd.options.map((o) => {
                              return rd[cd.key] == o.value ? o.label : "";
                            })}
                          </>
                        ) : cd.type == AfDataType.BOOLEAN ? (
                          <>{rd[cd.key] === true ? "true" : "false"}</>
                        ) : cd.type == AfDataType.DATE ? (
                          <>{moment(rd[cd.key], cd.dateFormat ? cd.dateFormat : "DD-MM-YYYY").format("DD-MM-YYYY")}</>
                        ) : cd.type == AfDataType.DATETIME ? (
                          <>{moment(rd[cd.key], cd.dateFormat ? cd.dateFormat : "DD-MM-YYYY").format("DD-MM-YYYY hh:mm")}</>
                        ) : cd.render ? (
                          cd.render(rd[cd.key], rd)
                        ) : cd.key == "foundAwbs" ? (
                          <>
                            <div className="flex gap-2">
                              {foundAwbs[rd.pickup_code]?.length || 0}
                              {foundAwbs[rd.pickup_code]?.length > 0 && (
                                <Popover>
                                  {({ open }) => (
                                    <>
                                      <Popover.Button className={"flex items-center"}>
                                        Show
                                        <ChevronDownIcon className="ui-open:rotate-180 ui-open:transform h-4" />
                                      </Popover.Button>
                                      <Transition
                                        show={open}
                                        enter="transition duration-100 ease-out"
                                        enterFrom="transform scale-95 opacity-0"
                                        enterTo="transform scale-100 opacity-100"
                                        leave="transition duration-75 ease-out"
                                        leaveFrom="transform scale-100 opacity-100"
                                        leaveTo="transform scale-95 opacity-0"
                                      >
                                        <Popover.Panel
                                          className={
                                            "absolute bg-white p-2 shadow-2xl border-2 border-secondary1 rounded-md -translate-x-full -translate-y-full flex flex-col gap-1"
                                          }
                                        >
                                          {foundAwbs[rd.pickup_code].map((p) => {
                                            return (
                                              <a
                                                target="_blank"
                                                className="underline hover:bg-blue-400 px-2"
                                                href={`/pod/tracking?awb=${p}`}
                                              >
                                                {p}
                                              </a>
                                            );
                                          })}
                                        </Popover.Panel>
                                      </Transition>
                                    </>
                                  )}
                                </Popover>
                              )}
                            </div>
                          </>
                        ) : cd.key == "sr_no" ? (
                          <div className="flex items-center gap-1">
                            {(currentPage - 1) * perPage + (j + 1)}
                            <span className={`${rowColor} w-4 h-4 inline-block`}></span>
                          </div>
                        ) : (
                          rd[cd.key]
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <table className="w-full text-sm text-left text-gray-500 border-r border-t hidden">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
            <tr>
              {columnData.map((c) => {
                return (
                  c.view && (
                    <th scope="col" className={`px-2 py-3 border-l border-b ${c.css ? c.css : ""}`} key={c.label + "data-tbl"}>
                      <div className="flex items-center">
                        {c.label}
                        {c.sort && GET_SORT_ICON(c.key, "")}
                      </div>
                      {c.filter && (
                        <>
                          {" "}
                          <input
                            type="text"
                            className="block p-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 "
                            placeholder="Search"
                          />
                        </>
                      )}
                    </th>
                  )
                );
              })}
            </tr>
          </thead>

          <tbody>
            {tableData.map((rd, j) => {
              return (
                <tr className="bg-white border-b text-black-900" key={"tbl-tr-" + j}>
                  {columnData.map((cd, i) => {
                    //console.log(cd.key,cd.render);
                    if (cd.key == "inv") {
                      //console.log(cd.render(rd[cd.key]));
                    }

                    let bgColor = "";
                    if (cd.bg_color_key) {
                      let index = columnData.findIndex((item) => item.key == cd.bg_color_key);
                      let bgColorAry = columnData[index].bg_color;
                      bgColor = bgColorAry[rd[cd.bg_color_key]];
                    }

                    return (
                      cd.view && (
                        <td className={`border-l px-2 py-1 bg-${bgColor}`} key={"tbl-td-" + i}>
                          {cd.type == AfDataType.CUSTOM ? (
                            customRenderFunction !== undefined ? (
                              customRenderFunction(rd)
                            ) : (
                              <button className="text-dark1" onClick={() => handleCustom(rd)}>
                                {customBtnText}
                              </button>
                            )
                          ) : cd.type == AfDataType.EDIT ? (
                            <div className="text-center">
                              <button className="text-dark1" onClick={() => handleEdit(rd)}>
                                Edit
                              </button>
                              <button className="text-dark1 font-semibold font-inter underline" onClick={() => setAWbData(rd)}>
                                Label
                              </button>
                            </div>
                          ) : cd.type == AfDataType.VIEW ? (
                            <button className="text-dark1" onClick={() => handleView(rd)}>
                              View
                            </button>
                          ) : cd.type == AfDataType.DB ? (
                            <>
                              {rd["_" + cd.key] ? (
                                rd["_" + cd.key][cd.db_col] == "EXA" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    id="svg16910"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 316 1024 256"
                                    xmlSpace="preserve"
                                  >
                                    <defs>
                                      <style type="text/css">{".st2 { fill: url(#SVGID_1_); }"}</style>
                                      <linearGradient
                                        id="SVGID_1_"
                                        gradientUnits="userSpaceOnUse"
                                        x1="14.7645"
                                        y1="447.1195"
                                        x2="1009.2247"
                                        y2="447.1195"
                                      >
                                        <stop offset="0" style={{ stopColor: "#034DA2" }} />
                                        <stop offset="0.5" style={{ stopColor: "#B646A2" }} />
                                        <stop offset="1" style={{ stopColor: "#FF6464" }} />
                                      </linearGradient>
                                    </defs>
                                    <path
                                      className="st2"
                                      d="M63.8,514.4h102.9v42.5H63.8H14.8V335.9h49.1h102.9v42.5l-102.9,0v47.4h85.8v42.5H63.8V514.4z M351.2,393.3h-48.4l-23.6,38.2l-4.8,7.8l-4.8-7.8L246,393.3h-48.4l47.4,76.8l-53.8,84.5h45.1l30.9-48.5l7.1-11.2l7.1,11.2l30.9,48.5h45.1l-53.8-84.5L351.2,393.3z M540.2,474.5c0,0.3,0,0.5,0,0.8h0v81.6h-42.1v-9.7c-12.3,7.1-26.6,11.2-41.8,11.2c-46.2,0-83.9-37.6-83.9-83.9c0-46.2,37.6-83.9,83.9-83.9C502.5,390.6,540.2,428.2,540.2,474.5z M498.1,474.5c0-23-18.7-41.8-41.8-41.8s-41.8,18.7-41.8,41.8c0,23,18.7,41.8,41.8,41.8C479.3,516.3,498.1,497.5,498.1,474.5z M810,336.2l-27.7,49.9l-95,171.1h58.9l65.6-118.1l65.6,118.1h55.4l-93.3-168L810,336.2z M960.2,335.9v221h49.1v-221H960.2z"
                                    />
                                  </svg>
                                ) : (
                                  rd["_" + cd.key][cd.db_col]
                                )
                              ) : (
                                "-"
                              )}
                            </>
                          ) : cd.type == AfDataType.SELECT ? (
                            <>
                              {cd.options.map((o) => {
                                return rd[cd.key] == o.value ? o.label : "";
                              })}
                            </>
                          ) : cd.type == AfDataType.BOOLEAN ? (
                            <>{rd[cd.key] === true ? "true" : "false"}</>
                          ) : cd.type == AfDataType.DATE ? (
                            <>{moment(rd[cd.key], cd.dateFormat ? cd.dateFormat : "DD-MM-YYYY").format("DD-MM-YYYY")}</>
                          ) : cd.type == AfDataType.DATETIME ? (
                            <>{moment(rd[cd.key], cd.dateFormat ? cd.dateFormat : "DD-MM-YYYY").format("DD-MM-YYYY hh:mm")}</>
                          ) : cd.render ? (
                            cd.render(rd[cd.key], rd)
                          ) : cd.key == "foundAwbs" ? (
                            <>
                              <div className="flex gap-2">
                                {foundAwbs[rd.pickup_code]?.length || 0}
                                {foundAwbs[rd.pickup_code]?.length > 0 && (
                                  <Popover>
                                    {({ open }) => (
                                      <>
                                        <Popover.Button className={"flex items-center"}>
                                          Show
                                          <ChevronDownIcon className="ui-open:rotate-180 ui-open:transform h-4" />
                                        </Popover.Button>
                                        <Transition
                                          show={open}
                                          enter="transition duration-100 ease-out"
                                          enterFrom="transform scale-95 opacity-0"
                                          enterTo="transform scale-100 opacity-100"
                                          leave="transition duration-75 ease-out"
                                          leaveFrom="transform scale-100 opacity-100"
                                          leaveTo="transform scale-95 opacity-0"
                                        >
                                          <Popover.Panel
                                            className={
                                              "absolute bg-white p-2 shadow-2xl border-2 border-secondary1 rounded-md -translate-x-full -translate-y-full flex flex-col gap-1"
                                            }
                                          >
                                            {foundAwbs[rd.pickup_code].map((p) => {
                                              return (
                                                <a
                                                  target="_blank"
                                                  className="underline hover:bg-blue-400 px-2"
                                                  href={`/pod/tracking?awb=${p}`}
                                                >
                                                  {p}
                                                </a>
                                              );
                                            })}
                                          </Popover.Panel>
                                        </Transition>
                                      </>
                                    )}
                                  </Popover>
                                )}
                              </div>
                            </>
                          ) : cd.key == "sr_no" ? (
                            (currentPage - 1) * perPage + (j + 1)
                          ) : (
                            rd[cd.key]
                          )}
                        </td>
                      )
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <nav className="flex items-center justify-between pt-4" aria-label="Table navigation">
        <span className="text-sm font-normal text-gray-500">
          Total: <span className="font-semibold text-gray-900">{itemCount}</span>
        </span>
        <ul className="inline-flex -space-x-px text-sm h-8">
          <li>
            <div
              onClick={() => setCurrentPage((prevData) => (prevData > 1 ? prevData - 1 : prevData))}
              className="flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 "
            >
              Previous
            </div>
          </li>
          {[...Array(pageCount)].map((_, p) => {
            //console.log("======> p", p);
            return currentPage - 1 === p ? (
              <li key={"paginate-" + p}>
                <a
                  type="button"
                  aria-current="page"
                  className="flex items-center justify-center px-3 h-8 text-blue-600 border border-gray-300 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                >
                  {p + 1}
                </a>
              </li>
            ) : (
              <li key={"paginate-" + p}>
                <a
                  type="button"
                  className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 "
                  onClick={() => setCurrentPage(p + 1)}
                >
                  {p + 1}
                </a>
              </li>
            );
          })}
          <li>
            <div
              // href="#"
              onClick={() => setCurrentPage((prevData) => (prevData < pageCount ? prevData + 1 : prevData))}
              className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 "
            >
              Next
            </div>
          </li>
        </ul>
      </nav>
      <ErrorMessage errors={errors} />
    </div>
  );
};

export { PickupDatatable };

const MemoizedPickupDatatable = React.memo(PickupDatatable);
export { MemoizedPickupDatatable };
